import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './CustomFalseCeiling.module.scss';
import { FalseCeilingLightLayout } from './CustomFalseCeilingConstants';
import TavViewSection from "./CustomTabViewSection";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";

const CustomFalseCeilingLightLayout = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  return (
    <section className={style.ceiling_plan_section}>
      <h4 className="section_heading">5. Ceiling Lighting Layout</h4>
      <div className={style.ceiling_plan_container}>
        <div className={style.false_ceiling_overview}>
          <div className={style.rightSection_tab}>
            <TavViewSection details={FalseCeilingLightLayout.rightBar} index={1} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} />
          </div>
        </div>
        <div className={style.reflected_plan}>
          <h4 className="sub_tab_heading">Lighting Layout</h4>
          <div className={style.canvas_height}>
            {
              pageDetails.images?.[0]?.imageUrl ? <img src={pageDetails.images?.[0]?.imageUrl} crossOrigin="anonymous" alt="Lighting Layout Image" className="image-view" /> :
                <div className={style.canvas_view_description}>
                  <h4 className={style.canvas_view_heading}>Reflected Ceiling Plan of False Ceiling showing Lights, Fan, AC, AC Cutouts seen</h4>
                  <div className={style.canvas_view_details}>
                    <p className={style.canvas_view_details_head}>Mandatory Details :</p>
                    <ul className={style.canvas_view_details_listing}>
                      <li>Overall room dimensions in plan</li>
                      <li>Dimensions showing Length of strip lights / cove lights or profile lights;</li>
                      <li>Dimensions showing Position of Light Fixtures (panel, spot, decorative) with spacing from wall to light & spacing between lights</li>
                      <li>Unique color coding / representations for different types of lights & fans with Legend</li>
                    </ul>
                  </div>
                </div>
            }
          </div>
        </div>
      </div>
      {updatedValues?.lightFixtures?.length ? <div className={style.rightSection_tab}>
        <h4 className="sub_tab_heading">Lighting Details</h4>
        <div className={style.plan_view_table}>
          <h4>Name</h4>
          <h4>Type</h4>
          <h4>No of Lights</h4>
          <h4>Color Code Wattage</h4>
          <h4>Running length in feet</h4>
        </div>
        {
          updatedValues?.lightFixtures?.map((e, id) => (
            <div className={style.plan_view_table} key={id}>
              <p>{e.name}</p>
              <p>{e.type}</p>
              <p>{e.no_of_lights}</p>
              <p>{e.colour_code_wattage}</p>
              <p>{e.running_length_in_feet}</p>
            </div>
          ))
        }
      </div> : ''
      }
    </section>
  )
}

export default CustomFalseCeilingLightLayout;